import {
    solicitacoesMenu,
    consultoriasMenu,
    pagamentosMenu
} from './consultorias/fornecedores/FornecedorMenu'

import { consultoriasGestoresMenu } from './consultorias/gestores/GestoresMenu'

import {
    uabsConsultoriasMenu,
    uabsPagamentosMenu
} from './consultorias/uabs/UabsMenu'

import { unidadesRegionaisMenu } from './consultorias/unidadesRegionais/UnidadesRegionaisMenu'

export default {
    name: 'APP SEBRAE',
    url: '/appsebrae',
    icon: 'fa fa-book',
    regras: [
        'APPSE-FORN-CONS-00',
        'APPSE-FORN-PAG-00',
        'APPSE-GEST-CONS-00',
        'APPSE-UABS-CONS-00',
        'APPSE-UABS-PAG-00',
        'APPSE-CONS-UR-00'
    ],
    children: [
        solicitacoesMenu,
        consultoriasMenu,
        pagamentosMenu,
        consultoriasGestoresMenu,
        uabsConsultoriasMenu,
        uabsPagamentosMenu,
        unidadesRegionaisMenu
    ]
}
